/** Spring @RequestParam List<String> lovTypes → lovTypes=a&lovTypes=b */
export function buildLovTypesQuery(lovTypes: string[]): string {
  const search = new URLSearchParams()
  for (const type of lovTypes) {
    if (type) {
      search.append('lovTypes', type)
    }
  }
  return search.toString()
}
